import React from 'react';

import ActiveFlatButton from '../buttons/ActiveFlatButton';
import InactiveFlatButton from '../buttons/InactiveFlatButton';
import QuarantineFilesView from './QuarantineFilesView';
import QuarantineSamplesView from './QuarantineSamplesView';
import './QuarantineDataTab.scss';
import { PillTabs } from 'new/elements/PillTabs';
import { Button } from 'new/elements/Button';
import { Refresh } from '@mui/icons-material';
import { Stack } from 'new/elements/Stack';
import { DEFAULT_PAGE_SIZE } from 'js/constants/paginationConstants';

const DisplayModes = {
  SAMPLES_VIEW: 'SAMPLES_VIEW',
  FILES_VIEW: 'FILES_VIEW',
};

const ModeToggleButton = (props) => {
  const { isActive, label, onClick } = props;

  return isActive ? (
    <ActiveFlatButton label={label} onClick={onClick} />
  ) : (
    <InactiveFlatButton label={label} onClick={onClick} />
  );
};

class QuarantineDataTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: DisplayModes.SAMPLES_VIEW,
    };
  }

  handlePillSelection = (selection) => {
    this.setState({
      mode: selection,
    });
  };

  onClickRefresh = () => {
    if (this.state.mode === DisplayModes.SAMPLES_VIEW) {
      this.props.fetchResourceQuarantineSamples(
        this.props.data?.id,
        this.props.resourceType,
        { page: 1, per_page: DEFAULT_PAGE_SIZE },
        'time',
      );
      return;
    }
    this.props.fetchResourceQuarantineFiles(
      this.props.data?.id,
      this.props.resourceType,
      { page: 1, size: DEFAULT_PAGE_SIZE },
      'lastWritten',
    );
  };

  render() {
    const {
      isLoadingErrorFiles,
      isLoadingErrorSamples,
      files,
      credentials,
      samples,
      ...otherProps
    } = this.props;
    const { mode } = this.state;
    const isFilesViewActive = mode === DisplayModes.FILES_VIEW;

    let contentView = null;

    switch (mode) {
      case DisplayModes.FILES_VIEW:
        contentView = (
          <QuarantineFilesView
            isLoading={isLoadingErrorFiles}
            files={files}
            credentials={credentials}
            {...otherProps}
          />
        );
        break;

      case DisplayModes.SAMPLES_VIEW:
      default:
        contentView = (
          <QuarantineSamplesView
            {...otherProps}
            isLoading={isLoadingErrorSamples}
            samples={samples}
          />
        );
    }

    return (
      <div className="tab-content data-source-files-tab">
        <div className="quarantine-data-tab">
          <div className="mode-selector">
            <Stack width="90px" />
            <PillTabs
              tabs={[
                {
                  value: DisplayModes.SAMPLES_VIEW,
                  label: 'Recent Errors',
                },
                {
                  value: DisplayModes.FILES_VIEW,
                  label: 'Exported Error Files',
                },
              ]}
              onSelectionChange={this.handlePillSelection}
              selected={this.state.mode}
            />
            <Button
              color="primary"
              variant="text"
              onClick={this.onClickRefresh}
              startIcon={<Refresh />}
            >
              Refresh
            </Button>
          </div>
          {contentView}
        </div>
      </div>
    );
  }
}

export default QuarantineDataTab;
